export const initialState = ({
  id,
  company,
  position,
  start,
  end,
  description,
} = {}) => ({
  id,
  company,
  position,
  start,
  end,
  description,
  isEditMode: !!id,
});

export const types = {
  SET_COMPANY: 'SET_COMPANY',
  SET_POSITION: 'SET_POSITION',
  SET_START: 'SET_START',
  SET_END: 'SET_END',
  SET_DESCRIPTION: 'SET_DESCRIPTION',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_COMPANY:
      return { ...state, company: payload };
    case types.SET_POSITION:
      return { ...state, position: payload };
    case types.SET_START:
      return { ...state, start: payload };
    case types.SET_END:
      return { ...state, end: payload };
    case types.SET_DESCRIPTION:
      return { ...state, description: payload };
    default:
      throw new Error();
  }
};
